import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useLocation } from "react-router-dom";

const SignupRedirect = () => {
    const { loginWithRedirect } = useAuth0();
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get("token");
        const email = params.get("email");
        const redirectPath = `/activateOld?token=${token}`;

        loginWithRedirect({
            authorizationParams: {
                screen_hint: 'signup',
                redirect_uri: `${window.location.origin}${redirectPath}`,
                login_hint: email,
            },
            appState: {returnTo: redirectPath},
            loginAfterSignUp: false
        }).then(r =>{
            console.log("Redirecting to signup with token:", token);
        });
    }, [loginWithRedirect, location.search]);

    return null;
};

export default SignupRedirect;